import React, { useId, useMemo, useState } from 'react'
import './MakroPage.scss'
import { Modal, useMediaQuery } from '@mui/material'
import MakroHead from './MakroHead/MakroHead'
import MUIRadioButton from './MUIRadioButton/MUIRadioButton'
import { useNavigate, useParams } from 'react-router'

import { ReactComponent as GridOnIcon } from '../components/assets/MakroPage/GridOnMakroMode.svg'
import { ReactComponent as GridOffIcon } from '../components/assets/MakroPage/GridOffMakroMode.svg'
import { ReactComponent as LineOnIcon } from '../components/assets/MakroPage/LineOnMakroMode.svg'
import { ReactComponent as LineOffIcon } from '../components/assets/MakroPage/LineOffMakroMode.svg'
import { ReactComponent as CarIcon } from '../components/assets/MakroPage/CarMakroHead.svg'
import { ReactComponent as ZoomIcon } from '../components/assets/MakroPage/ZoomIcon.svg'
import { digitalAppApi } from '../../store/services/digitalAppApi'
import MakroCard from './MakroCard/MakroCard'
import MakroFilter from './MakroFilter/MakroFilter'
import replaceAccent from './../../hooks/replaceAccent';
import { mainApi } from '../../store/services/mainApi'
import { useSelector } from 'react-redux'
import MakroCartModal from './MakroCartModal/MakroCartModal'
import MakroNavigator from './MakroNavigator/MakroNavigator'

const optionsMode = [
  {name: 'TPO', color: '#5FC56E '},
  {name: 'Makro', color: '#155dfc '}
]
const optionView = [
  { iconOn: <GridOnIcon />, iconOff: <GridOffIcon />, view: 'grid' },
  { iconOn: <LineOnIcon />, iconOff: <LineOffIcon />, view: 'line' },
]

const MakroPage = () => {
  const mobileView = useMediaQuery('(max-width: 798px)')
  const navigate = useNavigate()
  const tradeName = useParams().tradeName
  const uid = useId()
  const allItemsCartMakro = useSelector((state) => state.allItemsCart.allItemsCart)?.filter((item) => item?.sku?.includes('MCH'))

  const [view, setView] = useState(optionView[1]?.view)
  const [openFilter, setOpenFilter] = useState(false)
  const [isCartOpen, setIsCartOpen] = useState(false)
  const [filters, setFilters] = useState({
    category: [],
    brands: [],
    search: '',
    delivery: [],
  })

  const {
    data: contact,
    isLoading: isLoadingContact,
  } = mainApi.useGetBuisnessContactByTradeNameQuery(tradeName, {
    skip: !tradeName || mobileView,
  })
  const { data: marcoPersonal, isLoading: isLoadingMarcoPersonal } = digitalAppApi.useGetMakroPersonalQuery(tradeName, {skip: !tradeName})


  const filteredItems = useMemo(() => {
    if (!marcoPersonal?.data) return []

    return marcoPersonal.data.filter(item => {
      // 1. Фильтр по поиску (регистронезависимый)
      const matchesSearch = replaceAccent(item?.name)?.toLowerCase()?.includes(replaceAccent(filters?.search)?.toLowerCase()) || 
                           replaceAccent(item?.brand)?.toLowerCase()?.includes(replaceAccent(filters?.search)?.toLowerCase())

      // 2. Фильтр по категории (если категория выбрана)
      const itemCategories = item?.category ? item.category.split(',').map(cat => cat.trim()) : [];
    
      const matchesCategory = filters?.category?.length === 0 || 
                              itemCategories?.some(cat => filters?.category?.includes(cat));

      // 3. Фильтр по брендам (если выбрано хотя бы один бренд)
      const matchesBrand = filters?.brands?.length === 0 || filters?.brands?.includes(item?.brand)

      // 4. Фильтр по доставке (замените 'hasDelivery' на ваше поле из API)
      const matchesDelivery = !filters?.courierDelivery || item?.hasDelivery === true

      return matchesSearch && matchesCategory && matchesBrand && matchesDelivery
    })
  }, [marcoPersonal, filters])

  return (mobileView ? 
    <div className='MakroPageMobile'>
      <MakroHead 
        setOpenFilter={setOpenFilter} 
        setIsCartOpen={setIsCartOpen} 
        filters={filters} 
        setFilters={setFilters}
      />
      <MakroNavigator />
      <Modal open={openFilter} onClose={() => setOpenFilter(false)}>
        <MakroFilter 
          sx={{position: 'fixed', left: 0, top: 0, height: '100dvh',}}
          onClose={() => setOpenFilter(false)} 
          filters={filters} 
          setFilters={setFilters}
          items={marcoPersonal?.data?.length > 0 ? marcoPersonal?.data : []}
        />
      </Modal>
      <MakroCartModal 
        open={isCartOpen}
        onClose={() => setIsCartOpen(false)}
      />
      <div className="rw">
        <MUIRadioButton 
          sx={{ height: '38px', elem: { width: '38px', height: '38px', padding: '0 10px' } }}
          options={optionView} 
          value={view}
          onChange={(e) => setView(e.view)}
          getOptionLabel={(e) => e.view == view ? e?.iconOn : e.iconOff}
          getOptionValue={(e) => e.view}
        />

        <MUIRadioButton 
          sx={{ height: '38px', elem: { width: '100%', height: '38px', padding: '0 10px' } }}
          options={optionsMode} 
          value={optionsMode[1]?.name}
          onChange={() => navigate('/category/'+tradeName)}
          getOptionLabel={(e) => e?.name}
          getOptionValue={(e) => e?.name}
        />
      </div>

      <div className="rw" style={{ flexWrap: 'wrap', justifyContent: 'space-evenly'}}>
        {isLoadingMarcoPersonal ? Array(8).map((_, index) => <MakroCard key={uid+index} view={view}/>)
        : filteredItems?.length > 0 ?  
          filteredItems?.map((item, index) => (
            <MakroCard key={uid+index} item={item} view={view} />
          ))
        : null}
      </div>

    </div> :
    <div className='MakroPageWeb'>
      <div className="cl" style={{gap: '25px', maxWidth: '1140px'}}>
        <MakroNavigator />
        <MakroCartModal 
          open={isCartOpen}
          onClose={() => setIsCartOpen(false)}
        />
        <div className="rw MakroPageWeb__head">
          {!isLoadingContact && contact?.name && <h2>{contact?.name}</h2>}
          <MUIRadioButton 
            sx={{ height: '38px', elem: { width: '38px', height: '38px', padding: '0 10px' } }}
            options={optionView} 
            value={view}
            onChange={(e) => setView(e.view)}
            getOptionLabel={(e) => e.view == view ? e?.iconOn : e.iconOff}
            getOptionValue={(e) => e.view}
          />
          <MUIRadioButton 
            sx={{ height: '38px', elem: { width: '100%', height: '38px', padding: '0 10px' } }}
            options={optionsMode} 
            value={optionsMode[1]?.name}
            onChange={() => navigate('/category/'+tradeName)}
            getOptionLabel={(e) => e?.name}
            getOptionValue={(e) => e?.name}
          />

          <div className="Search">
            <input 
              type="text"
              className='Search__input'
              value={filters?.search}
              placeholder='Search...'
              onChange={(e) => {setFilters((prew) => ({...prew, search: e.target.value }))}}
            />
            <ZoomIcon />
          </div>

          <div className="Cart" onClick={() => setIsCartOpen(true)}>
            <div className="Cart__total">
              €{(allItemsCartMakro?.reduce((acc, curr) => acc + curr?.spoPrice * (curr?.quantity || 0), 0))?.toFixed(2)}
            </div>
            <div className="Cart__display">
              <CarIcon width={16} height={16}/>
              <span>{allItemsCartMakro?.length}</span>
            </div>
          </div>
        </div>
        <div className="rw">
          <MakroFilter
            sx={{ height: 'max-content',}}
            filters={filters} 
            setFilters={setFilters}
            items={marcoPersonal?.data?.length > 0 ? marcoPersonal?.data : []}
          />
          <div className="rw" style={{ flexWrap: 'wrap', justifyContent: 'space-evenly'}}>
            {isLoadingMarcoPersonal ? Array(8).map((_, index) => <MakroCard key={uid+index} view={view}/>)
            : filteredItems?.length > 0 ?  
              filteredItems?.map((item, index) => (
                <MakroCard key={uid+index} item={item} view={view} />
              ))
            : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MakroPage